import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "gfu-project-update__header",
  "data-qa": "project-update-header"
}
const _hoisted_2 = {
  class: "gfu-project-update__counter",
  "data-qa": "project-update-sequenceNumber"
}
const _hoisted_3 = {
  class: "gfu-project-update__date",
  "data-qa": "project-update-date"
}
const _hoisted_4 = {
  class: "gfu-project-update__title",
  "data-qa": "project-update-title"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  class: "gfu-project-update__abstract",
  "data-qa": "project-update-abstract"
}
const _hoisted_7 = {
  key: 1,
  class: "gfu-project-update__info"
}
const _hoisted_8 = { class: "gfu-project-update__info-left" }
const _hoisted_9 = { class: "gfu-project-update__info-icon-wrapper" }
const _hoisted_10 = { class: "gfu-project-update__info-right" }
const _hoisted_11 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectUpdates.UpdateSequenceNumberLabel, $props.update.sequenceNumber)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "date"),
        ($props.update.isPinned)
          ? (_openBlock(), _createBlock(_component_base_icon, {
              key: 0,
              name: "thumbtack",
              class: "gfu-project-update__date-icon"
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("h1", _hoisted_4, _toDisplayString($props.update.title), 1 /* TEXT */),
    ($props.update.hasImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          width: "100%",
          height: "auto",
          src: $props.update.imageUrl,
          alt: _ctx.Resources.format(_ctx.Resources.ProjectUpdates.UpdateSequenceNumberLabel, $props.update.sequenceNumber)
        }, null, 8 /* PROPS */, _hoisted_5))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_6, _toDisplayString($props.update.abstract), 1 /* TEXT */),
    ($props.showInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["gfu-project-update__info-icon", { '_tc--accent': $props.update.userInfo && $props.update.userInfo.likedAt !== null }])
              }, [
                _createVNode(_component_base_icon, {
                  title: _ctx.Resources.ProjectUpdates.LikeAction,
                  name: "thumbs-up"
                }, null, 8 /* PROPS */, ["title"]),
                _createTextVNode(" " + _toDisplayString($props.update.likesCount), 1 /* TEXT */)
              ], 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              class: "gfu-btn gfu-btn--primary gfu-btn--block gfu-btn--soft",
              href: $props.update.projectUpdateUrl,
              "data-qa": "project-update:ReadMore"
            }, [
              _createVNode(_component_base_icon, {
                name: "chevron-right",
                class: "_fr"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.Common.ReadMoreActionButton), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_11)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}